module.exports = __webpack_public_path__ + "img/project_icon_three.61c21370.png";